import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';
import Error404 from 'components/errors/Error404';
import Logout from 'components/authentication/card/Logout';
import LoginCuotas from 'components/authentication/card/LoginCuotas';
import Pagos from 'components/dashboards/default/Pagos';

const FalconRoutes = () => {
  return (
    <Routes>
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
      </Route>
      {/*- ------------- Authentication ---------------------------  */}
         <Route path="/" element={<LoginCuotas />} />
      <Route path="authentication/card/logout" element={<Logout />} />
      {/* //--- MainLayout Starts  */}
      <Route element={<MainLayout />}>
        {/* Padres */}
        <Route path="/estados-cuentas" element={<Pagos />} />
      </Route>
      {/* //--- MainLayout end  */}
      <Route path="login-cuotas" element={<LoginCuotas />} />
    </Routes>
  );
};

export default FalconRoutes;
